export const LOAD_PHOTOS = 'LOAD_PHOTOS'
export const LOAD_CARDS = 'LOAD_CARDS'
export const SHOW = 'SHOW'
export const HIDE = 'HIDE'